<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" width="700px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">
                        <slot name="header"></slot>
                    </span>
                </v-card-title>
                <v-card-text>
                    <slot></slot>
                </v-card-text>
                <v-card-actions>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <slot name="back">
                                <Button color="gray" text @click="goBack">Back</Button>
                            </slot>
                        </v-col>
                        <slot name="action"></slot>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    export default {
        name: "TermsBox",

        props: {
            backTo: {
                type: [Function, String, Number, Object],
                default: -1,
            },
        },

        data() {
            return {
                dialog: true,
            }
        },

        methods: {
            goBack() {
                return this.$goto(this.backTo)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .v-btn.v-size--default {
        font-size: 16px;
        font-weight: 600;
    }
</style>
